export default "__VITE_ASSET__Cm470Jmk__"